module.exports = __webpack_public_path__ + "img/esyoil-rating-gray.c1fc7b3.svg";